import axios from 'axios';

export const UPDATE_SHUMA_STATUS = '/inspections/updateShumaStatus';

export const updateShumaStatus = (shumaID, statusID) => {
  const data = {
    shumaID: parseInt(shumaID, 10),
    statusID: parseInt(statusID, 10),
  };
  return axios.post(UPDATE_SHUMA_STATUS, data)
    .then(response => {
      const {errorCode} = response.data;
      if (errorCode < 0) throw new Error();
    })
    .catch((err) => {
      err.clientMessage = 'Can\'t update data';
    });
};